export default function Column({
  fullWidth,
  children,
}: {
  fullWidth?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div className={`mb-6 w-full px-3 md:mb-0 ${fullWidth ? '' : 'md:w-1/2'}`}>
      {children}
    </div>
  );
}
